<template>
  <div class="text-center">
    <a :href="url">
      <img
        class="inline-block h-full max-w-3xs max-h-16 object-contain"
        style="mix-blend-mode: multiply;"
        :src="img"
        :alt="alt"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: "PartnerLogo",
  data() {
    return {};
  },
  props: {
    url: {
      type: String
    },
    alt: {
      type: String
    },
    img: {
      type: String
    }
  },
  components: {},
  methods: {},
  computed: {},
  created() {}
};
</script>